import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { WorkflowType } from '@frontend/workflow/types';
import React from 'react';

const ID = 'workflow-type-select';

export interface WorkflowTypeSelectProps extends Omit<SelectInputV2Props<WorkflowType>, 'options'> {}
export const WorkflowTypeSelect = (props: WorkflowTypeSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Workflow type'}
            options={Object.values(WorkflowType).map((c) => ({ label: c, value: c }))}
        />
    );
};

export default WorkflowTypeSelect;
